import posthog from 'posthog-js';
import { TrackingEvent } from './trackingEvents';

// trackEvent captures an event for tracking in our metrics system (currently PostHog).  The eventName is the name of
// the event and properties is an optional object that contains any additional information we want to send with the
// event.
export const trackEvent = (eventName: TrackingEvent, properties?: Record<string, unknown>): void => {
  posthog.capture(eventName, properties);
};
